// extracted by mini-css-extract-plugin
export default {"kitchen-component-cell":"lomNgdJ0gYJarffEfQwr"};